import m from "react";
import { styled as E } from "@mui/material/styles";
import { jsxs as x, jsx as a } from "react/jsx-runtime";
import C from "@mui/icons-material/AttachFile";
import L from "@mui/icons-material/Close";
import D from "@mui/material/IconButton";
import B from "@mui/material/InputAdornment";
import $ from "@mui/material/TextField";
import Y from "@mui/material/Typography";
const k = [
  "B",
  "kB",
  "MB",
  "GB",
  "TB",
  "PB",
  "EB",
  "ZB",
  "YB"
], w = [
  "B",
  "kiB",
  "MiB",
  "GiB",
  "TiB",
  "PiB",
  "EiB",
  "ZiB",
  "YiB"
], U = [
  "b",
  "kbit",
  "Mbit",
  "Gbit",
  "Tbit",
  "Pbit",
  "Ebit",
  "Zbit",
  "Ybit"
], G = [
  "b",
  "kibit",
  "Mibit",
  "Gibit",
  "Tibit",
  "Pibit",
  "Eibit",
  "Zibit",
  "Yibit"
], b = (i, t, e) => {
  let n = i;
  return typeof t == "string" || Array.isArray(t) ? n = i.toLocaleString(t, e) : (t === !0 || e !== void 0) && (n = i.toLocaleString(void 0, e)), n;
};
function F(i, t) {
  if (!Number.isFinite(i))
    throw new TypeError(`Expected a finite number, got ${typeof i}: ${i}`);
  t = {
    bits: !1,
    binary: !1,
    ...t
  };
  const e = t.bits ? t.binary ? G : U : t.binary ? w : k;
  if (t.signed && i === 0)
    return ` 0 ${e[0]}`;
  const n = i < 0, s = n ? "-" : t.signed ? "+" : "";
  n && (i = -i);
  let r;
  if (t.minimumFractionDigits !== void 0 && (r = { minimumFractionDigits: t.minimumFractionDigits }), t.maximumFractionDigits !== void 0 && (r = { maximumFractionDigits: t.maximumFractionDigits, ...r }), i < 1) {
    const c = b(i, t.locale, r);
    return s + c + " " + e[0];
  }
  const o = Math.min(Math.floor(t.binary ? Math.log(i) / Math.log(1024) : Math.log10(i) / 3), e.length - 1);
  i /= (t.binary ? 1024 : 1e3) ** o, r || (i = i.toPrecision(3));
  const f = b(Number(i), t.locale, r), u = e[o];
  return s + f + " " + u;
}
const R = E("label")`
  position: relative;

  input {
    opacity: 0 !important;
  }

  span {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 2;
    display: flex;
    align-items: center;
  }

  span.MuiFileInput-placeholder {
    color: gray;
  }
`, Z = {
  Label: R
}, _ = m.forwardRef((i, t) => {
  const {
    text: e,
    isPlaceholder: n,
    placeholder: s,
    ...r
  } = i, o = m.useId();
  return /* @__PURE__ */ x(Z.Label, {
    htmlFor: o,
    children: [/* @__PURE__ */ a("input", {
      ...r,
      ref: t,
      id: o
    }), e ? /* @__PURE__ */ a("span", {
      "aria-placeholder": s,
      className: n ? "MuiFileInput-placeholder" : "",
      children: e
    }) : null]
  });
});
function O(i) {
  return i.length > 0;
}
function j(i) {
  return i.reduce((t, e) => t + e.size, 0);
}
function d(i) {
  return typeof window < "u" && i instanceof File;
}
function K(i) {
  return Array.from(i);
}
function V(i, t) {
  if (i.length < t)
    return i;
  const n = Math.floor((t - 1) / 2);
  return `${i.slice(0, n)}\u2026${i.slice(
    i.length - n
  )}`;
}
function nt(i) {
  const {
    value: t,
    onChange: e,
    disabled: n,
    getInputText: s,
    getSizeText: r,
    placeholder: o,
    hideSizeText: f,
    inputProps: u,
    InputProps: c,
    multiple: h,
    className: A,
    ...S
  } = i, g = m.useRef(null), y = h || u?.multiple || c?.inputProps?.multiple || !1, M = () => {
    const l = g.current;
    l && (l.value = "");
  }, P = (l) => {
    const I = l.target.files, T = I ? K(I) : [];
    M(), e?.(y ? T : T[0]);
  }, N = (l) => {
    l.preventDefault(), !n && e?.(h ? [] : null);
  }, p = Array.isArray(t) ? O(t) : d(t), z = () => {
    if (t === null || Array.isArray(t) && t.length === 0)
      return o || "";
    if (typeof s == "function" && t !== void 0)
      return s(t);
    if (t && p) {
      if (Array.isArray(t) && t.length > 1)
        return `${t.length} files`;
      const l = d(t) ? t.name : t[0]?.name || "";
      return V(l, 20);
    }
    return "";
  }, v = () => {
    if (typeof r == "function" && t !== void 0)
      return r(t);
    if (p) {
      if (Array.isArray(t)) {
        const l = j(t);
        return F(l);
      }
      if (d(t))
        return F(t.size);
    }
    return "";
  };
  return /* @__PURE__ */ a($, {
    type: "file",
    disabled: n,
    onChange: P,
    className: `MuiFileInput-TextField ${A || ""}`,
    InputProps: {
      startAdornment: /* @__PURE__ */ a(B, {
        position: "start",
        children: /* @__PURE__ */ a(C, {})
      }),
      endAdornment: /* @__PURE__ */ x(B, {
        position: "end",
        style: {
          visibility: p ? "visible" : "hidden"
        },
        children: [f ? null : /* @__PURE__ */ a(Y, {
          variant: "caption",
          mr: "2px",
          className: "MuiFileInput-Typography-size-text",
          children: v()
        }), /* @__PURE__ */ a(D, {
          "aria-label": "Clear",
          title: "Clear",
          size: "small",
          disabled: n,
          className: "MuiFileInput-IconButton",
          onClick: N,
          children: /* @__PURE__ */ a(L, {
            fontSize: "small"
          })
        })]
      }),
      ...c,
      inputProps: {
        text: z(),
        multiple: y,
        isPlaceholder: t === null || Array.isArray(t) && t.length === 0,
        ref: g,
        placeholder: o,
        ...u,
        ...c?.inputProps
      },
      inputComponent: _
    },
    ...S
  });
}
export {
  nt as MuiFileInput
};
